import type { ReleaseHistoryPage } from '@/types/automationReleases.ts';

export function compositionOptions(
  releases: ReleaseHistoryPage['releases'],
  selectedId?: string | null,
) {
  const options = [...new Map(releases.map((item) => [item.id, item])).values()].map((item) => ({
    value: item.id,
    label: `${item.name} · ${item.status} · ${item.id}${item.record_valid === false ? ` · unavailable: ${item.record_error ?? 'invalid retained record'}` : ''}`,
    disabled: item.record_valid === false,
  }));
  if (selectedId && !options.some((item) => item.value === selectedId))
    options.unshift({
      value: selectedId,
      label: `Selected candidate · ${selectedId}`,
      disabled: false,
    });
  return options;
}
